import AvailableSlots from "./AvailableSlots";

const Booking = (props) => {
    return (<AvailableSlots/>);
}

export default Booking;